import { render, staticRenderFns } from "./OTAgenda.vue?vue&type=template&id=6ff87e5a&"
import script from "./OTAgenda.vue?vue&type=script&lang=js&"
export * from "./OTAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports